/* eslint-disable */
import React, { useState } from 'react';
import styled from 'styled-components';

import HTMLWrapper from '../HTMLWrapper';
import Text from '../Text';
import Section, { Overline } from '../layouts/Section';
import { Grid, Cell } from '../layouts/Grid';
import theme from '../../../styles/theme';
import getTextInElement from '../helper-functions/getTextInElement';
import Button from '@basic/BasicButton';
import SlideDown from 'react-slidedown';
import Chevron from '@images/icons/Chevron_Down_Brand.svg';
import OverflowScreenshot from '../OverflowScreenshot';

const {
	colors,
	breakPoints: { screenQuery },
} = theme;

const Wrapper = styled(Section)`
	${screenQuery.large} {
		display: none;
	}
`;

const ScreenshotDesktopGrid = styled(Grid)``;

const ScreenshotHeaderWrapper = styled.div`
	margin-bottom: 10px;
	img {
		margin-right: 10px;
		width: 15px;
	}
	h5 {
		display: inline;
		vertical-align: middle;
		font-size: 20px;
	}
`;
const ScreenshotText = styled.div`
	.screenshot-wrapper {
		padding: 30px;
		transition:
			border-bottom 0.25s ease,
			box-shadow 0.5s ease;
		border-bottom: 2px solid ${colors.newBrand.coolGrey};
		display: grid;
		grid-template-columns: auto 1fr auto;
		grid-gap: 20px;
	}

	.screenshot-wrapper.active {
		box-shadow: 0px 8px 48px rgba(46, 64, 100, 0.15);
		border-bottom: none;
		background-color: ${colors.white};
	}
	position: relative;
	:hover {
		cursor: pointer;
	}

	p.screenshot-element {
		color: ${colors.newBrand.lightGrey};
	}

	width: 100%;

	margin-top: 30px;
	&:last-child {
		margin-bottom: 0px;
	}

	.screenshot-icon {
		width: 26px;
		transition: all 0.25s;
		filter: ${props => (props.active ? ' brightness(100%)' : ' brightness(0)')};
	}

	h5 {
		font-size: 20px;
	}

	@media only screen and (max-width: ${theme.breakPoints.large}) {
		:hover {
			cursor: inherit;
		}
	}
`;

const MobileWrapper = styled(Section)`
	display: none;
	@media only screen and (max-width: ${theme.breakPoints.large}) {
		display: block;
	}
`;

const MenuArrow = styled.img`
	width: 12px;
	transition: all 0.5s;

	filter: ${props => (props.active ? ' brightness(100%)' : ' brightness(0)')};
	transform: ${props => (props.active ? ' rotate(180deg)' : ' rotate(275deg)')};
`;

const LargeScreenshotAccordion = props => {
	const {
		screenshotContent,
		noTopPadding,
		noBottomPadding,
		overline,
		link,
		linkText,
		backgroundColor,
		className,
	} = props;

	const screenshots = [
		{
			screenshot: screenshotContent.screenshot1?.gatsbyImageData,
			headerIcon: screenshotContent.headerIcon1?.file.url,
			header: screenshotContent.screenshot1DescriptionHeader,
			smallHeader: screenshotContent.screenshot1SmallHeader,
			text: getTextInElement(
				screenshotContent.screenshot1DescriptionText?.childMarkdownRemark.html,
				'p'
			),
			backgroundColor: colors.gradients.screenshotBlockBlue,
		},
		{
			screenshot: screenshotContent.screenshot2?.gatsbyImageData,
			headerIcon: screenshotContent.headerIcon2?.file.url,
			header: screenshotContent.screenshot2DescriptionHeader,
			smallHeader: screenshotContent.screenshot2SmallHeader,
			text: getTextInElement(
				screenshotContent.screenshot2DescriptionText?.childMarkdownRemark.html,
				'p'
			),
			backgroundColor: colors.gradients.screenshotBlockPurple,
		},
		{
			screenshot: screenshotContent?.screenshot3?.gatsbyImageData,
			headerIcon: screenshotContent.headerIcon3?.file.url,
			header: screenshotContent.screenshot3DescriptionHeader,
			smallHeader: screenshotContent.screenshot3SmallHeader,
			text: getTextInElement(
				screenshotContent.screenshot3DescriptionText?.childMarkdownRemark.html,
				'p'
			),
			backgroundColor: colors.gradients.screenshotBlockYellow,
		},
		{
			screenshot: screenshotContent?.screenshot4?.gatsbyImageData,
			headerIcon: screenshotContent.headerIcon4?.file.url,
			header: screenshotContent.screenshot4DescriptionHeader,
			smallHeader: screenshotContent.screenshot4SmallHeader,
			text: getTextInElement(
				screenshotContent.screenshot4DescriptionText?.childMarkdownRemark.html,
				'p'
			),
			backgroundColor: colors.gradients.screenshotBlockBlue,
		},
		{
			screenshot: screenshotContent?.screenshot5?.gatsbyImageData,
			headerIcon: screenshotContent.headerIcon5?.file.url,
			header: screenshotContent.screenshot5DescriptionHeader,
			smallHeader: screenshotContent.screenshot5SmallHeader,
			text: getTextInElement(
				screenshotContent.screenshot5DescriptionText?.childMarkdownRemark.html,
				'p'
			),
			backgroundColor: colors.gradients.screenshotBlockPurple,
		},
	];

	const [screenIndex, setScreenIndex] = useState(0);

	return [
		<Wrapper
			key="screenshots-desktop"
			noTopPadding={noTopPadding}
			noBottomPadding={noBottomPadding}
			backgroundColor={backgroundColor}
			className={className}
		>
			<ScreenshotDesktopGrid>
				<Cell align="center" span={6}>
					{(overline || screenshotContent.overline) && (
						<Overline className="overline">
							{overline || screenshotContent.overline}
						</Overline>
					)}
					<Text component="h2" color="black">
						{screenshotContent.screenshotSectionHeader}
					</Text>
					<HTMLWrapper
						replaceNode={{ p: 'b2' }}
						html={
							screenshotContent?.screenshotSectionDescription
								?.childMarkdownRemark.html
						}
						className="subheader"
					/>
					{linkText && (
						<Button style={{ marginTop: '10px' }} arrow secondary to={link}>
							{linkText}
						</Button>
					)}
					{screenshots.map((screenshot, index) => {
						if (!screenshot.screenshot) {
							return null;
						}
						const active = index === screenIndex;
						return (
							<ScreenshotText
								onClick={() => setScreenIndex(index)}
								active={active}
								index={index}
							>
								{screenshot.smallHeader && (
									<Text
										component="caps"
										css={{ marginBottom: 5 }}
										semiBold
										className="screenshot-element"
									>
										{screenshot.smallHeader.toUpperCase()}
									</Text>
								)}
								<div className={`screenshot-wrapper ${active && 'active'}`}>
									<img
										src={screenshot.headerIcon}
										class="screenshot-icon"
										alt=""
										active={active}
									/>
									<div>
										<Text
											component="h5"
											className="screenshot-header screenshot-element"
										>
											{screenshot.header}
										</Text>
										<Text component="b5" className="screenshot-element">
											<SlideDown>
												{active && <div>{screenshot.text}</div>}
											</SlideDown>
										</Text>
									</div>
									<MenuArrow src={Chevron} active={active} alt="" />
								</div>
							</ScreenshotText>
						);
					})}
				</Cell>

				<OverflowScreenshot
					flipX
					image={screenshots[screenIndex].screenshot}
					backgroundColor={
						screenshots[screenIndex].backgroundColor ||
						colors.gradients.screenshotBlockBlue
					}
				/>
			</ScreenshotDesktopGrid>
		</Wrapper>,
		<MobileWrapper key="screenshots-mobile">
			<Grid>
				<Cell span={12}>
					<Text component="h2" color="black">
						{screenshotContent.screenshotSectionHeader}
					</Text>
					<HTMLWrapper
						replaceNode={{ p: 'b2' }}
						html={
							screenshotContent?.screenshotSectionDescription
								?.childMarkdownRemark.html
						}
						className="subheader"
					/>
				</Cell>
				{screenshots.map(screenshot => {
					if (!screenshot.screenshot) {
						return null;
					}
					return [
						<Cell span={4} spanMd={4} spanSm={4}>
							{screenshot.smallHeader && (
								<Text
									component="caps"
									css={{ marginBottom: 5 }}
									semiBold
									className="screenshot-element"
								>
									{screenshot.smallHeader.toUpperCase()}
								</Text>
							)}
							<ScreenshotHeaderWrapper>
								<img src={screenshot.headerIcon} alt="" />

								<Text component="h5" color="black">
									{screenshot.header}
								</Text>
							</ScreenshotHeaderWrapper>

							<Text component="b4">{screenshot.text}</Text>
						</Cell>,
						<Cell
							key={screenshot.screenshot}
							span={8}
							spanMd={8}
							startMd={5}
							spanSm={8}
							startSm={5}
						>
							{/* <img css={{ width: "100%" }} src={screenshot.screenshot} alt={screenshot.header} /> */}
						</Cell>,
					];
				})}
			</Grid>
		</MobileWrapper>,
	];
};

export default LargeScreenshotAccordion;
